import React from "react";
import { COMPANY } from "../data";
import { PageHero, useSeo } from "../ui";

const EFFECTIVE_DATE = "2026년 9월 22일";

const SECTIONS = [
  {
    title: "제1조 (목적)",
    body: [
      `이 약관은 ${COMPANY.name}(${COMPANY.nameKo}, 이하 "회사")가 운영하는 홈페이지에서 제공하는 서비스의 이용 조건과 절차, 회사와 회원의 권리·의무 및 책임사항을 정하는 것을 목적으로 합니다.`,
    ],
  },
  {
    title: "제2조 (용어의 정의)",
    list: [
      '"서비스" — 회사가 홈페이지를 통해 제공하는 자료 제공, 제품 판매, 개발 의뢰 접수 등 일체의 서비스',
      '"회원" — 이 약관에 동의하고 회원등록을 완료한 자',
      '"아이디" — 회원 식별과 서비스 이용을 위해 등록한 이메일 주소',
    ],
  },
  {
    title: "제3조 (약관의 효력과 변경)",
    list: [
      "이 약관은 홈페이지에 게시함으로써 효력이 발생합니다.",
      "회사는 필요한 경우 관련 법령을 위반하지 않는 범위에서 약관을 변경할 수 있습니다.",
      "약관을 변경할 때에는 적용일자와 변경 사유를 적어 적용일 7일 전부터 홈페이지에 공지합니다. 회원에게 불리한 변경은 30일 전부터 공지합니다.",
      "변경된 약관에 동의하지 않는 회원은 탈퇴할 수 있습니다.",
    ],
  },
  {
    title: "제4조 (회원가입)",
    list: [
      "가입을 원하는 자가 약관에 동의하고 가입 양식을 작성해 신청하면, 회사가 이를 승낙함으로써 회원으로 등록됩니다.",
      "만 14세 미만은 가입할 수 없습니다.",
      "타인의 정보를 이용하거나 허위 정보를 기재한 경우 회사는 가입을 거절하거나 사후에 이용계약을 해지할 수 있습니다.",
    ],
  },
  {
    title: "제5조 (회원의 의무)",
    list: [
      "회원은 아이디와 비밀번호를 스스로 관리해야 하며, 이를 제3자가 이용하게 해서는 안 됩니다.",
      "회원은 등록 정보에 변경이 있을 경우 즉시 수정해야 합니다.",
      "회원은 서비스를 통해 얻은 자료를 회사의 사전 동의 없이 영리 목적으로 복제·배포·판매할 수 없습니다.",
      "회원은 서비스의 정상적인 운영을 방해하는 행위를 해서는 안 됩니다.",
    ],
  },
  {
    title: "제6조 (자료의 이용)",
    body: [
      "회사가 제공하는 자료(소프트웨어, 회로도, 문서 등)의 지식재산권은 회사 또는 정당한 권리자에게 있습니다. 회원은 개인적·내부적 용도로 자료를 이용할 수 있으며, 자료별로 별도의 이용 조건이 명시된 경우 그 조건을 따릅니다.",
    ],
  },
  {
    title: "제7조 (제품의 구매와 청약철회)",
    list: [
      "제품 구매 조건, 배송, 교환·반품에 관한 사항은 개별 제품 안내와 관련 법령을 따릅니다.",
      "회원은 제품을 받은 날부터 7일 이내에 청약을 철회할 수 있습니다.",
      "회원의 책임 있는 사유로 제품이 멸실·훼손된 경우, 회원의 사용으로 제품의 가치가 현저히 감소한 경우, 주문에 따라 개별 제작된 제품의 경우에는 청약철회가 제한될 수 있습니다.",
      "제품에 하자가 있는 경우에는 위 제한과 관계없이 교환 또는 환불이 가능합니다.",
    ],
  },
  {
    title: "제8조 (서비스의 중단)",
    body: [
      "회사는 설비 점검·교체, 통신 장애, 천재지변 등 부득이한 사유가 있는 경우 서비스 제공을 일시적으로 중단할 수 있으며, 이 경우 사전에 공지합니다. 다만 예측할 수 없는 사유로 중단된 경우에는 사후에 공지할 수 있습니다.",
    ],
  },
  {
    title: "제9조 (회원 탈퇴 및 이용 제한)",
    list: [
      "회원은 언제든지 홈페이지에서 탈퇴할 수 있으며, 회사는 즉시 처리합니다.",
      "회원이 이 약관을 위반하거나 서비스의 정상적인 운영을 방해한 경우, 회사는 사전 통지 후 이용을 제한하거나 이용계약을 해지할 수 있습니다.",
    ],
  },
  {
    title: "제10조 (개인정보의 보호)",
    body: [
      "회사는 회원의 개인정보를 관련 법령에 따라 보호합니다. 수집 항목, 이용 목적, 보유 기간 등 구체적인 사항은 개인정보처리방침에서 정합니다.",
    ],
  },
  {
    title: "제11조 (책임의 제한)",
    list: [
      "회사는 천재지변 등 불가항력으로 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.",
      "회사는 회원의 귀책사유로 발생한 서비스 이용 장애에 대해 책임을 지지 않습니다.",
      "회사가 제공한 자료를 회원이 이용해 발생한 결과에 대해서는, 회사의 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.",
    ],
  },
  {
    title: "제12조 (분쟁의 해결)",
    body: [
      "이 약관과 관련한 분쟁은 대한민국 법을 적용하며, 회사와 회원 간 협의로 해결합니다. 협의가 이루어지지 않을 경우 민사소송법이 정한 관할 법원에 제소합니다.",
    ],
  },
];

export default function Terms() {
  useSeo({
    title: "이용약관 | I.META 아이닷메타",
    description: "아이닷메타(I.META) 홈페이지 서비스 이용약관입니다.",
    path: "/terms",
  });

  return (
    <>
      <PageHero
        kicker="TERMS"
        title="이용약관"
        desc={`${COMPANY.name}(${COMPANY.nameKo}) 홈페이지 서비스 이용에 관한 약관입니다.`}
      />

      <section className="section section--tight">
        <article className="legal">
          <p className="legal__date">시행일: {EFFECTIVE_DATE}</p>

          {SECTIONS.map((sec) => (
            <section key={sec.title} className="legal__section">
              <h2 className="legal__title">{sec.title}</h2>
              {sec.body && sec.body.map((t) => <p key={t} className="legal__p">{t}</p>)}
              {sec.list && (
                <ol className="legal__list">
                  {sec.list.map((t) => <li key={t}>{t}</li>)}
                </ol>
              )}
            </section>
          ))}
        </article>
      </section>
    </>
  );
}
